import {useData} from "vike-react/useData";
import {ApiArticle, ApiArticleComment, ApiProfileUserData} from "#/src/definitions/ApiDefinitions";
import {ArticleCommentsView} from "#/src/pages/(profile)/my-profile/ArticleCommentsView";
import {usePageContext} from "vike-react/usePageContext";
import {DataWrapped} from "#/src/definitions/AppDefinitions";

export function CommentsPeek() {
  const {data: profileData} = useData() as DataWrapped<ApiProfileUserData>;
  const {urlPathname} = usePageContext();

  function render() {
    return <div className="comment-wrapper">
      <div className="title-between mb-4 mt-4">
        <h2 className="basic-headline basic-headline-sm">
          Ostatnie komentarze
        </h2>
        {urlPathname.startsWith("/my-profile") && <a href={"/my-profile/comments"} className="more-link">
          Pokaż więcej
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="#EEF5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>}
      </div>
      {renderComments()}
    </div>
  }

  function renderComments() {
    const grouped = Object.values(profileData.user.commentsPeek.reduce((acc, comment) => {
      const articleId = comment.relatedArticle.id;
      if (!acc[articleId]) {
        acc[articleId] = {article: comment.relatedArticle, comments: []};
      }

      acc[articleId].comments.push(comment);
      return acc;
    }, {} as Record<number, { article: ApiArticle, comments: ApiArticleComment[] }>));

    return grouped.map(({article, comments}) => <ArticleCommentsView key={article.id} article={article} comments={comments}/>);
  }

  return render();
}